<script>
  import { createEventDispatcher } from 'svelte';

  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';

  const dispatch = createEventDispatcher();

  export let show;
  export let mobile = false;

  let yesActionClick = function () {
    dispatch('yes-click');
  };

  let cancelClick = function () {
    dispatch('cancel');
  };
</script>

<style style="text/scss" lang="scss">
  * :global(.modal__container) {
    display: flex;
    width: 440px !important;
    padding: 2.5px 40px !important;
    justify-content: center !important;
    align-items: center !important;
  }

  * :global(.alert-yes-btn) {
    height: 48px !important;
    color: #ff5567 !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    border: none !important;
    border-radius: 15px !important;
    background: #fde7e7 !important;
    box-shadow: unset !important;

    &:hover {
      background: #ff5567 !important;
      color: white !important;
    }
  }

  .alert-container {
    text-align: center;

    .delete-icon-container {
      background-color: #fff1f1;
      width: 56px;
      height: 56px;
      border-radius: 999px;
      text-align: center;
      margin: auto;
      align-items: center;
      justify-content: center;
      display: flex;
    }

    .alert-question {
      color: #1c1c1c;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; /* 142.857% */
      text-transform: uppercase;
      margin-top: 24px;
    }

    .alert-object-text {
      color: #717171;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      margin-top: 12px;
    }

    .alert-actions {
      margin-top: 20px;
      margin-left: auto;
      margin-right: auto;

      .alert-cancel-btn {
        color: #000;
        font-size: 15px;
        margin-top: 12px;
        font-weight: 500;
        border: none;
        background: transparent;
      }
    }
  }
</style>

<div class="svelte-modal">
  <Modal
    on:close={cancelClick}
    on:show={() => {
      dispatch('show');
    }}
    allowClose={true}
    closeOnOverlayClick={true}
    mobile={mobile}
    containerClass="remove-post-modal-container"
    bind:show={show}
    showCloseButton={false}>
    <div slot="content" class="alert-container">
      <div class="delete-icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
          <path
            d="M19.3213 9.45215L18.4004 20.1846C18.3227 21.0897 17.5647 21.7852 16.6562 21.7852H7.49219C6.58371 21.7852 5.82576 21.0897 5.74805 20.1846L4.82715 9.45215L6.32129 9.32324L7.24316 20.0566C7.25433 20.1859 7.36245 20.2852 7.49219 20.2852H16.6562C16.786 20.2852 16.8941 20.1859 16.9053 20.0566L17.8271 9.32324L19.3213 9.45215ZM14.2041 3.78516C15.0476 3.78534 15.7713 4.38739 15.9248 5.2168L16.1982 6.69727H20.5742V8.19727H3.57422V6.69727H7.9502L8.22363 5.2168C8.37717 4.38739 9.10084 3.78534 9.94434 3.78516H14.2041ZM9.94434 5.28516C9.82396 5.28534 9.72111 5.37183 9.69922 5.49023L9.47559 6.69727H14.6729L14.4492 5.49023C14.4273 5.37183 14.3245 5.28534 14.2041 5.28516H9.94434Z"
            fill="#E82C3F" />
        </svg>
      </div>
      <div class="alert-question">REMOVE POST?</div>
      <div class="alert-object-text">
        Are you sure you want to remove the embedded post from this list? You can always re-add it later.
      </div>
      <div class="alert-actions">
        <Button on:click={yesActionClick} text={'Remove'} class="alert-yes-btn" />

        <button on:click|preventDefault|stopPropagation={cancelClick} class="alert-cancel-btn"> Cancel </button>
      </div>
    </div>
  </Modal>
</div>
